// 运营-关联关系api
import request from '@/util/request'

// 获取现有商户
export function relatedBusiness (id, params) {
  return request({
    url: `/maintain-s/station/${id}/queryRelated/businesses`,
    method: 'get',
    params
  })
}
// 现有商户解除关系
export function delRelatedBus (id, groupId) {
  return request({
    url: `/maintain-s/station/${id}/deleteRelated/business/${groupId}`,
    method: 'delete'
  })
}
// 现有商户增加关系
export function AddRelatedBus (data) {
  return request({
    url: `/maintain-s/station/addRelated/business`,
    method: 'post',
    data
  })
}

// 获取用户列表
export function relatedUser (id, params) {
  return request({
    url: `/maintain-s/station/${id}/queryRelated/users`,
    method: 'get',
    params
  })
}
// 用户解除关系
export function delRelatedUser (id, groupId) {
  return request({
    url: `/maintain-s/station/${id}/deleteRelated/user/${groupId}`,
    method: 'delete'
  })
}
// 现有用户增加关系
export function AddRelatedUser (data) {
  return request({
    url: `/maintain-s/station/addRelated/user`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/maintain/plant/relative.js